
import { defineComponent } from "@vue/runtime-core";


export default defineComponent({
  data: () => ({
    uniInNumbers: [
      {
        title: '2700+',
        icon: '',
        subtitle: 'студентов'
      },
      {
        title: '52',
        icon: '',
        subtitle: 'образовательных программ'
      },
      {
        title: '73,77',
        icon: '',
        subtitle: 'cредний балл ЕГЭ'
      },
      {
        title: '13',
        icon: '',
        subtitle: '9 - выпускающих и <br/> 4 - базовых кафедр'
      },
    ]
  }),
  methods: {
    getImageURL(path: string) {
      // return new URL(`../assets/${path}`, import.meta.url).href;
    }
  }
})
